import { onMount } from "solid-js";

export default function GoogleAdsScript() {
  onMount(() => {
    const googleadsScript = document.createElement("script");
    googleadsScript.src =
      "https://www.googletagmanager.com/gtag/js?id=AW-1018861338";
    googleadsScript.async = true;
    document.head.appendChild(googleadsScript);

    googleadsScript.addEventListener("load", () => {
      const googleadsTrackingScript = document.createElement("script");
      googleadsTrackingScript.text = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-1018861338');
        `;
      document.head.appendChild(googleadsTrackingScript);
    });
  });

  return null;
}
